import React from "react";

const Vehiclecard2page = ({logo, color, vheading, des}) => {
  return (
    <div className="p-2 text-sm  mt-2 rounded-md flex items-center gap-2 h-[70px] w-[130px]" style={{backgroundColor:color}}>
        <div>
            <img src={logo} alt={vheading} />
        </div>
        <div className="text-xs">
            <p>{vheading}</p>
            <p>{des}</p>
        </div>
      
    </div>
  );
};

export default Vehiclecard2page;
